import { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { starfield } from './magic';

/**
 * A random sky (magic.ts `starfield`): a fresh layout every mount, spread
 * evenly. `twinkle` adds three composited layers that fade as a whole; without
 * it the sky is one static SVG and costs nothing per frame.
 */
export function Starfield({ className, twinkle = false, cols, rows }: { className?: string; twinkle?: boolean; cols?: number; rows?: number }) {
  const stars = useMemo(() => starfield(Math.floor(Math.random() * 2 ** 32), cols, rows), [cols, rows]);
  const layers = twinkle ? [null, 0, 1, 2] : [null];
  return layers.map((layer) => (
    <svg
      key={layer ?? 'still'}
      className={cn('pointer-events-none fixed inset-0 size-full text-white', layer != null && 'magic-twinkle', className)}
      style={layer != null ? { animationDelay: `${-layer * 1.5}s` } : undefined}
      aria-hidden="true"
    >
      {stars.map((star, i) => ((star.twinkle == null || !twinkle ? layer == null : layer === i % 3) && (
        <circle key={i} cx={`${star.x}%`} cy={`${star.y}%`} r={star.r} fill="currentColor" opacity={star.o} />
      )))}
    </svg>
  ));
}
